var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.28 841.89",
    style: {
      enableBackground: "new 0 0 595.28 841.89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-width:15;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#000000;stroke-width:15;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M417.94,290.18h49.85c8.28,0,15,6.72,15,15v225.01c0,8.28-6.72,15-15,15H128.2c-8.28,0-15-6.72-15-15V305.18 c0-8.28,6.72-15,15-15h49.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M417.94,320.42h33.66c0.55,0,1,0.45,1,1v193.04c0,0.55-0.45,1-1,1H331.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.68,515.45H144.39c-0.55,0-1-0.45-1-1V321.42c0-0.55,0.45-1,1-1h33.66"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 298.1,
    y1: 515.45,
    x2: 298,
    y2: 515.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 331.45,
    y1: 482.36,
    x2: 403.16,
    y2: 482.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 331.45,
    y1: 449.35,
    x2: 403.16,
    y2: 449.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 192.96,
    y1: 482.36,
    x2: 264.68,
    y2: 482.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 238.41,
    y1: 605.55,
    x2: 357.59,
    y2: 605.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 192.96,
    y1: 449.35,
    x2: 264.68,
    y2: 449.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M417.94,250.42v151.75c0,7.73-6.27,14-14,14h-85.38c-1.27,0-2.49,0.48-3.41,1.35l-12.25,11.44 c-2.74,2.56-7,2.5-9.68-0.12l-11.45-11.24c-0.93-0.92-2.19-1.43-3.5-1.43h-86.21c-7.73,0-14-6.27-14-14V250.42 c0-7.73,6.27-14,14-14H298h105.94C411.67,236.42,417.94,242.69,417.94,250.42z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "253.02,605.55 265.17,545.69 330.77,545.19 342.92,605.55  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M216.91,304.69c0-7.18,5.82-13,13-13h36.73c19.5,0,58.22-20.57,66.17-24.86c0.67-0.36,1.47,0.12,1.47,0.88 v93.64c0,0.76-0.8,1.24-1.47,0.88c-7.93-4.25-46.48-24.57-66.18-24.57h-36.73c-7.18,0-13-5.82-13-13V304.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M237.66,337.72v47.61c0,0.55,0.45,1,1,1h12.96c9.63,0,18.09-5.34,18.09-94.76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 367.99,
    y1: 314.53,
    x2: 379.25,
    y2: 314.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 363.87,
    y1: 284.6,
    x2: 373.62,
    y2: 278.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 363.87,
    y1: 344.83,
    x2: 373.62,
    y2: 350.46
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.bb56dedc12c5be8b8d5c6d9d5820b688.svg";
export { ForwardRef as ReactComponent };